<!-- display top posts  -->
<!-- UI  https://lucid.app/lucidchart/80a846c8-f2fd-4a77-bad8-3b3a9693b98f/edit?existing=1&token=f11d6aaea35bd5e87fc270500415170326833ca4-eml%3Dabdelrahman.g%2540ariany.com%26ts%3D1643738227%26uid%3D160359065&docId=80a846c8-f2fd-4a77-bad8-3b3a9693b98f&shared=true&page=u6kPtBC-DqqK#?referringapp=slack -->

<div *ngIf="itemsToShow" class="bg-white container mb-3 mt-lg-5 p-4 slidesContainer">
    <!-- display translated title top posts -->
    <h5 class="ranking-header pl-2">{{l("TrendingPosts")}}</h5>

    <!-- loop to display top posts, each in one row, as image and beside post by and post date -->
    <div class="m-auto w-100 h-100">
        <div *ngFor="let item of items; let i = index" class="nd-sm-sidebars d-block">
            <div class="single-item row w-100 align-items-center">
                <!-- display top post image  with link to the post popup -->
                <div class="col">
                    <img *ngIf="item?.type!='SINGLEVIDEO' && item?.type!='NEWSDIGEST'" class="small-image"
                        [src]="attachmentBaseUrl + '/'  + item?.imageUrl" alt="" (click)="ShowViewPost(item?.id)"
                        onerror="this.src='../../../../../assets/placeholders/ranking-placeholder.png'" />

                    <video *ngIf="item?.type=='SINGLEVIDEO' || item?.type=='NEWSDIGEST'" (click)="ShowViewPost(item?.id)"
                        [attr.src]="attachmentBaseUrl + '/' + item?.imageUrl" class="small-image"></video>

                </div>
                <!-- display top post by  with link to the post popup -->
                <div class="single-item-body col" [ngClass]="true ? '' : 'd-flex flex-row'">

                    <div class="text-blue ">

                        <a href="javascript:;" (click)="ShowViewPost(item?.id)">{{item?.description}}</a>
                    </div>
                    <div>
                        <a href="javascript:;" (click)="ShowViewPost(item?.id)"> {{item?.createdOn}}</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-sm-sidebars d-none h-100 w-100">
           
                <p-carousel class="hiddenDotsIndicator hiddenIndicator  slidersContainerCarousel  h-100 w-100" [numVisible]="1.5"
             [value]="items"  [circular]="false">
                <ng-template let-item pTemplate="item">
                    <div 
                    [ngClass]="items.length >1 ? 'slide-md-Section' : 'slide-sm-Section'" >
                        
                <img *ngIf="item?.type!='SINGLEVIDEO' && item?.type!='NEWSDIGEST'" 
                [ngClass]="items.length >1 ? 'slide-medium-image' : 'slide-small-image'"  
                            [src]="attachmentBaseUrl + '/'  + item?.imageUrl" alt=""
                            (click)="ShowViewPost(item?.id)"
                            onerror="this.src='../../../../../assets/placeholders/UpcomingEvents.png'" />

                        <video *ngIf="item?.type=='SINGLEVIDEO' || item?.type=='NEWSDIGEST'" (click)="ShowViewPost(item?.id)"
                            [attr.src]="attachmentBaseUrl + '/' + item?.imageUrl"   [ngClass]="items.length >1 ? 'slide-medium-image' : 'slide-small-image'"   ></video>
                           
                           <div class="slide-single-item-body pt-3">
                          <h5>
                                <a class="text-black"  href="javascript:;" (click)="ShowViewPost(item?.id)">{{item?.description | textSubstring: 10 }} ... </a>
                            </h5>
                            <span>
                                <a  class="text-black" href="javascript:;" (click)="ShowViewPost(item?.id)"> {{item?.createdOn | date: "MMM d, y"}}</a>
                            </span>
                        </div>
           </div>
           </ng-template>
           </p-carousel>

        </div>
    </div>

</div>
<!-- link to the post popup view chield-->
<div *ngIf="!itemsToShow" class="bg-white container mb-3 mt-lg-5 p-0 slidesContainer noslidedata">

    <img class="small-image" src="" alt=""
        onerror="this.src='../../../../../assets/placeholders/TopPosts-placeholder.jpg'" />

</div>